import { Controller } from "@hotwired/stimulus"

// The campaign funnel's add-funds stage (holiday dollar-a-day KTD8): the
// first click on Copy address or Add funds tells the server, once per page.
// Fire and forget: a beacon that fails never gets in the saver's way.
export default class extends Controller {
  static values = { url: String }

  clicked(event) {
    if (this.sent || !event.target.closest("[data-add-funds-choice]")) return
    this.sent = true

    fetch(this.urlValue, {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
      },
      body: JSON.stringify({ stage: "add_funds" })
    }).catch(() => {})
  }
}
